import { CloseModal as UsecaseReduxCloseModal } from 'domain/usecases/modal/redux';

import { ReduxCloseModal } from 'data/store/reducer/modal/usecases';

/**
 * send request via REDUX.
 */
export const makeReduxCloseModal = (): UsecaseReduxCloseModal =>
  new ReduxCloseModal();
